import { combineReducers } from 'redux'

import { currentSmartSegmentReducer } from './currentSmartSegment'
import { smartSegmentsReducer } from './smartSegments'

export default combineReducers({
  list: smartSegmentsReducer,
  current: currentSmartSegmentReducer,
})
